import { ReactNode } from "react";
import { Box, BoxProps, Typography, TypographyProps } from "@mui/material";
import styles from "./SettingsCard.module.css";

export interface SettingsCardProps {
	renderers?: {
		header?: {
			iconRenderer: () => ReactNode;
			titleRenderer: () => ReactNode;
		};
	};
	slots?: {
		settingsCard?: BoxProps;
		header?: BoxProps;
		headerText?: TypographyProps;
		body?: BoxProps;
		headerIcon?: BoxProps;
	};
	children?: ReactNode;
}

export function SettingsCard({ renderers, children, slots }: SettingsCardProps) {
	return (
		<Box className={styles.settingsCard} {...slots?.settingsCard}>
			{renderers?.header && (
				<Box className={styles.header} {...slots?.header}>
					<Box className={styles.headerIcon} {...slots?.headerIcon}>
						{renderers.header.iconRenderer()}
					</Box>
					<Typography className={styles.headerText} {...slots?.headerText}>
						{renderers.header.titleRenderer()}
					</Typography>
				</Box>
			)}
			<Box className={styles.body} {...slots?.body}>
				{children}
			</Box>
		</Box>
	);
}
